import { Controller } from '@hotwired/stimulus';
import VanillaCalendar from '@uvarov.frontend/vanilla-calendar';
import Axios from "../axios";

export default class extends Controller {
    connect() {

        const context = this;

        // Config https://vanilla-calendar.frontend.uvarov.tech/api/
        context.calendar = new VanillaCalendar(this.element, {
            settings: {
                lang: 'lt',
            },
            actions: {
                clickArrow(event, year, month) {

                    const date = new Date(year, month, 1);
                    const nextDate = new Date(year, month, 1);
                    nextDate.setMonth(date.getMonth() + 1);
                    context.addEventPopups(
                        context.formatDate(date),
                        context.formatDate(nextDate),
                    );
                },
            },
            popups: {},
        });

        context.calendar.init();

        const today = new Date();
        today.setDate(1);
        context.addEventPopups(context.formatDate(today));
    }

    addEventPopups(dateFrom, dateTo = dateFrom) {

        const context = this;
        context.getEventInfo(dateFrom, dateTo).then(response => {
            if (response && response.data) {
                const data = response.data;
                const popups = {};
                for (let id in data) {

                    if ( !popups[data[id]['date']] ) {
                        popups[data[id]['date']] = {
                            modifier: 'has-events',
                            html: `<a href="${ data[id]['url'] }">${ data[id]['title'] }</a>`,
                        }
                    } else {
                        console.log("in");
                        let html = popups[data[id]['date']]['html'];
                        html += `<a href="${ data[id]['url'] }">${ data[id]['title'] }</a>`;
                        popups[data[id]['date']]['html'] = html;
                    }
                }

                console.log(popups)

                context.calendar.popups = popups;
                context.calendar.update();
            }
        });
    }

    async getEventInfo(dateFrom, dateTo) {

        let response = null;
        try {
            response = await Axios.post(`/wp-json/api/events-list`, {
                date_from: dateFrom,
                date_to: dateTo,
            });
            response = response.data.data;
        } catch (error) {
            response = error.response.data.data;
        }

        return response;
    }

    formatDate(date) {
        return date.toLocaleDateString("lt-LT", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        })
    }
}
